import { createApi } from '@reduxjs/toolkit/query/react';
import type { AuditLogFilters, AuditLogMeta } from 'features/AuditLogs_v2/utils/searchBuilder';
import { axiosBaseQuery } from 'services/_infra/rtkBaseQuery';

export const auditLogsV2Api = createApi({
  reducerPath: 'auditLogsV2Api',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['AuditLog', 'AuditLogMeta'],
  endpoints: (builder) => ({
    getAuditLogs: builder.query({
      // undefined fields are to satisfy the type signature of the baseQuery, but are not actually used in the request
      query: (params: AuditLogFilters) => ({
        url: '/audit-logs',
        method: 'GET',
        data: undefined,
        params,
        headers: undefined,
        responseType: undefined,
        msAuth: undefined,
      }),
      transformResponse: (response) => response ?? { page: 1, pageSize: 10, totalPages: 0, results: [] }, //fallback to default shape if response is undefined
    }),
    getAuditLogsMeta: builder.query<AuditLogMeta, void>({
      query: () => ({
        url: '/audit-logs/meta',
        method: 'GET',
        data: undefined,
        params: undefined,
        headers: undefined,
        responseType: undefined,
        msAuth: undefined,
      }),
      transformResponse: (response: { domains: Record<string, string[]>; categories: string[] }): AuditLogMeta =>
        response ?? { domains: {}, categories: [] },
      providesTags: ['AuditLogMeta'],
    }),
    getAuditLogById: builder.query({
      query: (id: number) => ({
        url: `/audit-logs/${id}`,
        method: 'GET',
        data: undefined,
        params: undefined,
        headers: undefined,
        responseType: undefined,
        msAuth: undefined,
      }),
      transformResponse: (response) => response?.data ?? null,
      providesTags: ['AuditLog'],
    }),
  }),
});

export const { 
  useGetAuditLogsQuery, // main query for fetching audit logs. Has parameters for filtering, pagination, and sorting.
  useGetAuditLogsMetaQuery, // query for fetching audit logs metadata. Does not require any parameters.
  useGetAuditLogByIdQuery, // query for fetching a single audit log by its numeric id.
  } = auditLogsV2Api;
